import {
    VISCERAL_FAT_INFO, VISCERAL_FAT_PANEL_TITLE,
    VISCERAL_FAT_POPOVER_TITLE
} from '../../../assets/ApplicationCopy';
import { AbstractPanel } from './AbstractPanel';
import { CONSTANTS } from '../../../assets/UIConstants';
import { Scan } from '../../../data_layer/models/Scan';
import { FullSummaryCategories } from '../../pages/FullSummary';
import { NumericRange } from '../Graphs/AreaGraph';
import { Comparision } from '../../pages/Public';

export class VisceralFatLevel extends AbstractPanel {
    protected panelId: string = 'visceral-fat-level';
    protected panelTitle: string = VISCERAL_FAT_PANEL_TITLE;
    protected popoverTitle: string = VISCERAL_FAT_POPOVER_TITLE;
    protected popoverBody: string | JSX.Element = VISCERAL_FAT_INFO;
    protected goodValueComparision = Comparision.GREATER_THAN;
    protected goodValueComparisionValue = 11;
    protected fullSummaryLinkPath: string = FullSummaryCategories.VisceralFat;

    protected graphUnit: string = '';

    protected yValueExtractor(scan: Scan): number {
        return scan.scan_results.visceralFatLevel;
    }

    protected graphColor: string = CONSTANTS.COLORS.THEME_ORANGE;

    protected get yAxisRange(): NumericRange {
        return {
            min: 0,
            max: 20
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/dashboardPanels/VisceralFatLevel.tsx